var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "vs-slilder-tp" },
    [
      _c("vueSlider", {
        staticClass: "vs-slilder__input-tp",
        attrs: {
          type: "range",
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          height: _vm.height,
          tooltip: "hover",
          lazy: true,
          value: _vm.renderValue,
          "dot-size": _vm.minimized ? 0 : 16,
          "bg-style": {
            backgroundColor: "rgba(255, 255, 255, 0.3)",
            borderRadius: 0,
            cursor: "pointer"
          },
          "process-style": {
            backgroundColor: "#e81a65",
            borderRadius: 0
          }
        },
        on: {
          callback: _vm.handleValue,
          "drag-start": function($event) {
            return _vm.$emit("dragstart", $event)
          },
          "drag-end": function($event) {
            return _vm.$emit("dragend", $event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "tooltip",
              fn: function(ref) {
                var scopedValue = ref.value
                return [_vm._t("floater", null, { value: scopedValue })]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }